<template>
  <el-aside width="180px" class="nav-left-componets">
    <!-- <nav-left-shopinfo></nav-left-shopinfo> -->
    <img
      v-if="(oemInstitution && oemInstitution.whAppLogo) || isOwn"
      class="logo"
      :src="
        oemInstitution && oemInstitution.whAppLogo
          ? oemInstitution.whAppLogo
          : require(`@/assets/img/logo.png`)
      "
      alt=""
    />
    <h2 v-else>
      {{ oemInstitution ? oemInstitution.whAppName : isOwn ? "微火" : "" }}
    </h2>
    <el-menu
      :default-active="pathActive"
      :router="true"
      text-color="#666666"
      active-text-color="#666666"
    >
      <template v-for="menu in menuList">
        <el-submenu
          :index="`${menu.path}`"
          v-if="menu.children && menu.children.length > 1"
        >
          <template slot="title">
            <div
              class="menu-title"
              :class="{
                active: menu.isActive,
              }"
            >
              <!-- <div class="icon-box" :title="menu.name">
                <i class="iconfont" :class="menu.icon" v-if="menu.icon"></i>
              </div> -->
              <i class="iconfont" :class="[`icon-${menu.icon}`]"></i>
              <span>{{ menu.name }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
          <el-menu-item-group class="nav-left-menu-item-group">
            <el-menu-item
              v-for="item in menu.children"
              :key="item.path"
              :index="`${item.path}`"
              class="nav-left-menu-item"
              :class="{
                active: item.isActive,
              }"
              :title="item.name"
            >
              <div>
                <!-- <i class="iconfont" :class="item.icon" v-if="item.icon"></i> -->
                <span>{{ item.name }}</span>
              </div>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item
          v-else
          :key="menu.icon"
          :index="menu.path"
          :class="{ active: menu.isActive }"
        >
          <div
            class="menu-title"
            :class="{
              active: menu.isActive,
            }"
          >
            <i class="iconfont" :class="[`icon-${menu.icon}`]"></i>
            <span slot="title">{{ menu.name }}</span>
          </div>
        </el-menu-item>
      </template>
    </el-menu>
  </el-aside>
</template>

<script>
import navLeftShopinfo from "@/components/navLeftShopinfo.vue";
import { mapState } from "vuex";
import { menuListMixins } from "@/mixins/menuListMixins";
export default {
  mixins: [menuListMixins],
  data() {
    return {
      pathActive: "/",
    };
  },
  mounted() {},
  computed: {},
  components: {
    navLeftShopinfo,
  },
};
</script>

<style lang="less" scoped>
.nav-left-componets {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 180px;
  min-width: 180px;
  overflow-y: auto;
  border-right: 1px solid #eeeeee;
  box-sizing: border-box;
  background: linear-gradient(
    134.24deg,
    rgba(255, 241, 240, 1) 0%,
    rgba(255, 250, 245, 1) 100%
  );
  z-index: 2;
  &::-webkit-scrollbar {
    display: none;
  }
  :deep(.el-menu) {
    background-color: transparent;
  }
  .logo {
    width: 112px;
    height: 49px;
    margin: 15px auto;
    display: block;
  }
  h2 {
    text-align: center;
    font-size: 26px;
    padding: 10px;
  }
  .el-menu {
    text-align: left;
    border: 0;
    background-color: transparent;
    :deep(.el-menu.el-menu--inline) {
      ul {
        position: relative;
        li {
          text-indent: 10px;
        }
        &::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          width: 2px;
          background: linear-gradient(
            180deg,
            rgba(255, 93, 44, 1) 0%,
            rgba(255, 255, 255, 1) 100%
          );
          left: 35px;
        }
      }
      :deep(.el-menu-item) {
        &:hover,
        &:active,
        &:focus {
          background-color: transparent;
        }
      }
    }
    .el-submenu,
    .el-menu-item {
      margin-bottom: 8px;
      :deep(i.el-submenu__icon-arrow) {
        display: none;
      }
      &.is-active {
        :deep(i.el-submenu__icon-arrow) {
          color: #fff;
        }
      }
      &:hover,
      &:active,
      &:focus {
        background-color: transparent;
      }

      &.is-opened {
        .menu-title {
          &:hover {
            background: linear-gradient(
              90deg,
              rgba(255, 70, 47, 1) 0%,
              rgba(255, 99, 43, 1) 99.31%
            );
          }
          color: #fff;
          border-radius: 4px;
          background: linear-gradient(
            90deg,
            rgba(255, 70, 47, 1) 0%,
            rgba(255, 99, 43, 1) 99.31%
          );
          .el-icon-arrow-right {
            color: #fff;
            transform: rotate(90deg);
          }
          .iconfont {
            color: #fff;
          }
        }
      }
    }
    :deep(.el-submenu__title),
    & > .el-menu-item {
      height: 35px;
      line-height: 35px;
      padding: 0 15px !important;
      &:hover {
        background-color: transparent;
      }
    }
    .el-menu-item {
      // padding-left: 30px !important;
      height: 35px;
      line-height: 35px;
      margin-bottom: 10px;
      &.active {
        // background-color: #ecf5ff;
        color: rgba(255, 72, 47, 1) !important;
      }
      &:hover {
        background-color: transparent;
      }
    }
    .iconfont {
      font-size: 20px;
      margin-right: 20px;
    }
    .blue {
      color: #43a0ff;
    }
    .green {
      color: #67c23a;
    }
    .orange {
      color: #f56c6c;
    }
    .yellow {
      color: #ffa51e;
    }
    .menu-title,
    &.menu-title {
      display: flex;
      align-items: center;
      color: rgba(74, 74, 74, 1);
      width: 100%;
      font-size: 14px;
      border-radius: 8px;
      padding: 0 13px !important;
      box-sizing: border-box;
      .el-icon-arrow-right {
        color: #4a4a4a;
        font-size: 16px;
        transition: transform 0.3s;
      }
      span {
        display: inline-block;
        width: 115px;
      }
      &:hover {
        // background: rgba(255, 255, 255, 1);
        background: #ffd3c7;
      }
      &.collapse {
        span {
          display: none;
        }
      }
      &.active {
        color: #fff;
        border-radius: 4px;
        background: linear-gradient(
          90deg,
          rgba(255, 70, 47, 1) 0%,
          rgba(255, 99, 43, 1) 99.31%
        );
        .el-icon-arrow-right {
          color: #fff;
          transform: rotate(90deg);
        }
        .iconfont {
          color: #fff;
        }
      }
      .el-icon {
        font-size: 12px;
        transition: transform 0.3s;
        margin-right: -8px;
      }
      .iconfont {
        font-size: 18px;
        margin-right: 5px;
        color: rgba(74, 74, 74, 1);
      }
    }
  }
}
</style>
